import { useField } from "formik";
import { useCallback } from "react";
import { stringifyError } from "../../utils";
const useFormikDropdown = (name, { onBlur, onChange, onCreateOption } = {}) => {
  const [field, meta, helpers] = useField(name);
  const handleBlur = useCallback(
    (event) => {
      helpers.setTouched(true);
      if (onBlur) {
        onBlur(event);
      }
    },
    [helpers, onBlur]
  );
  const handleChange = useCallback(
    (newValue) => {
      const optionToCreate = Array.isArray(newValue) ? newValue.find((v) => v.newOption) : (newValue == null ? void 0 : newValue.newOption) ? newValue : void 0;
      if (!optionToCreate || optionToCreate && !onCreateOption) {
        helpers.setValue(newValue);
      }
      if (onChange) {
        onChange(newValue);
      }
    },
    [helpers, onChange, onCreateOption]
  );
  return [
    {
      ...field,
      onBlur: handleBlur,
      onChange: handleChange,
      onCreateOption,
      validationMessage: meta.touched && !!meta.error ? stringifyError(meta.error) : void 0,
      validationStatus: meta.touched && !!meta.error ? "error" : void 0
    }
  ];
};
export {
  useFormikDropdown
};
//# sourceMappingURL=useFormikDropdown.js.map
